module.exports = __webpack_public_path__ + "img/tag-value.10a8af45.svg";